const localStoragePrefix = 'storeeel_group_click'

export const groupClickRepository = {
  set(groupId, campaignId) {
    const expireAt = Date.now() + 24 * 60 * 60 * 1000; // 24時間後

    // 既存の全データを取得
    const existing = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");

    // groupIdごとのデータがなければ初期化
    if (!existing[groupId]) {
      existing[groupId] = {};
    }

    // campaignIdにTTLを設定
    existing[groupId][campaignId] = { TTL: expireAt };

    // 保存
    localStorage.setItem(localStoragePrefix, JSON.stringify(existing));
  },
  getAllValid() {
    const now = Date.now();
    const result = {};

    try {
      const data = JSON.parse(localStorage.getItem(localStoragePrefix) || '{}');

      Object.entries(data).forEach(([groupId, campaigns]) => {
        const validCampaigns = {};

        Object.entries(campaigns).forEach(([campaignId, info]) => {
          if (info.TTL > now) {
            validCampaigns[campaignId] = info;
          }
        });

        if (Object.keys(validCampaigns).length > 0) {
          result[groupId] = validCampaigns;
        }
      });

      return result;
    } catch {
      return {};
    }
  },
  removeExpiredCampaigns() {
    const data = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");
    const now = Date.now();
    let updated = false;

    Object.keys(data).forEach(groupId => {
      const campaigns = data[groupId];
      Object.keys(campaigns).forEach(campaignId => {
        if (campaigns[campaignId].TTL <= now) {
          delete campaigns[campaignId];
          updated = true;
        }
      });

      // groupが空になったら削除（任意）
      if (Object.keys(campaigns).length === 0) {
        delete data[groupId];
      }
    });

    if (updated) {
      localStorage.setItem(localStoragePrefix, JSON.stringify(data));
    }
  },
  remove(groupId) {
    const data = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");

    if (groupId in data) {
      delete data[groupId];
      localStorage.setItem(localStoragePrefix, JSON.stringify(data));
    }
  }
}
